import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { FormInput, FormInputMultiline, FormInputBlur } from 'elements/Inputs/FormInput/';
import { StyledLabel } from 'elements/Label/Label';
import { FormDropdown } from 'elements/Inputs/FormInput/Dropdown/Dropdown';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import { DeleteButton, StyleDropdown, StyleInput, StyleLabelText } from '../AsFoundTestTableSection/AsFoundTestSection.styled';
import { selectAsLeftTestTableSectionData } from './AsLeftTestTableSection.data';
import { keyName } from './AsLeftTestTableSection.constants';
import { errorMessageMap } from '../../Sections.constants';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1
    }
}));

const AsLeftTestTableSection = (props) => {
    const { selectedTag, formData, changeHandler, formName, isFormReadOnly, userRole, updateFormData, altTestPoint } = props;
    const classes = useStyles();
    const keyData = keyName?.filter((key) => Object.keys(key)?.includes(formName));
    const formDeleteButton = (field) => field.isDelete
        ? (
            <DeleteButton>
                <IconButton style={{ padding: '0' }} aria-label="delete" onClick={() => { updateFormData(field.key, keyData[0][formName], 'Alt'); }}>
                    <DeleteIcon style={{ color: 'var(--primary)', fontSize: '1rem' }} id={`delete-${field.key}`} />
                </IconButton>
            </DeleteButton>
        ) : (
            <StyleInput
                formName={formName}
            >
                <FormInput
                    id={field.key}
                    name={field.key}
                    label={field.label}
                    value={field.value}
                    isRequired={field.isRequired}
                    isCalculated={field.isCalculated}
                    isCalculatedNew={field.isCalculatedNew}
                    isDisabled={field.isDisabled}
                    readOnly={field.readOnly || isFormReadOnly}
                    handleChange={changeHandler}
                    direction={field.direction}
                    textAlign={field.textAlign}
                    type={field.type}
                    padding={field.padding}
                    width={field.width}
                    labelWidth={field.labelWidth}
                    marginLeft={field.marginLeft}
                    maxLength={field.maxLength}
                    marginRight={field.marginRight}
                    fontSize={field.fontSize}
                    marginBottom={field.marginBottom}
                    marginTop={field.marginTop}
                    inputMarginLeft={field.inputMarginLeft}
                    borderRight={field.borderRight}
                    height={field.height}
                    borderBottom={field.borderBottom}
                    borderTop={field.borderTop}
                    borderLeft={field.borderLeft}
                    isLabelNew={field.isLabelNew}
                    inputMarginRight={field.inputMarginRight}
                    isLabelBold={field.isLabelBold}
                    userRole={userRole}
                    color={field.color}
                    fontWeight={field.fontWeight}
                    fontColor={field.fontColor}
                    isDeleteLabel={field.isDeleteLabel}
                    textAlignLabel={field.textAlignLabel}
                    hasAltTestGasConcentrationError={field.hasAltTestGasConcentrationError}
                    testGasConcentrationMessage={field.testGasConcentrationMessage}
                />
            </StyleInput>
        );
    const formInputBlur = (field) => field.isBlur
        ? (
            <FormInputBlur
                id={field.key}
                name={field.key}
                label={field.label}
                value={field.value}
                isCalculated={field.isCalculated}
                isCalculatedNew={field.isCalculatedNew}
                direction={field.direction}
                isRequired={field.isRequired}
                handleChange={changeHandler}
                type={field.type}
                width={field.width}
                padding={field.padding}
                labelWidth={field.labelWidth}
                marginLeft={field.marginLeft}
                textAlign={field.textAlign}
                readOnly={field.readOnly || isFormReadOnly}
                maxLength={field.maxLength}
                marginRight={field.marginRight}
                borderRight={field.borderRight}
                height={field.height}
                marginBottom={field.marginBottom}
                borderBottom={field.borderBottom}
                borderTop={field.borderTop}
                borderLeft={field.borderLeft}
                inputMarginRight={field.inputMarginRight}
                marginTop={field.marginTop}
                userRole={userRole}
                isLabelNew={field.isLabelNew}
                isLabelBold={field.isLabelBold}
                fontWeight={field.fontWeight}
                isDisabled={field.isDisabled}
                hasDPSError={field.hasDPSError}
                hasTestPointError={field.hasTestPointError}
                textAlignLabel={field.textAlignLabel}
                inputMarginLeft={field.inputMarginLeft}
                displayPopUp={field.displayPopUp}
                testPointErrorMessage={errorMessageMap[formName] || errorMessageMap.default}
            />
        ) : formDeleteButton(field);
    const formMultilineInput = (field) => field.isMultiLine
        ? (
            <FormInputMultiline
                id={field.key}
                name={field.key}
                value={field.value}
                maxLength={field.maxLength}
                handleChange={changeHandler}
                type={field.type}
                inputWidth={field.inputWidth}
                userRole={userRole}
                width={field.labelWidth}
                marginRight="0"
                borderBottom={field.borderBottom}
                borderTop={field.borderTop}
                borderLeft={field.borderLeft}
                borderRight={field.borderRight}
                inputMarginLeft={field.inputMarginLeft}
                inputMarginRight={field.inputMarginRight}
                readOnly={field.readOnly || isFormReadOnly}
                isDisabled={field.isDisabled}
            />
        ) : formInputBlur(field);
    const formDropdownInput = (field) => field.isDropdown ? (
        <StyleDropdown
            formName={formName}
        >
            <FormDropdown
                id={field.key}
                name={field.key}
                label={field.label}
                value={field.value}
                placeholder={field.placeholder}
                handleChange={changeHandler}
                options={field.options}
                isRequired={field.isRequired}
                width={field.width}
                inputTextAlign={field.inputTextAlign}
                labelWidth={field.labelWidth}
                readOnly={isFormReadOnly || field.readOnly}
                direction={field.direction}
                isDisabled={field.isDisabled}
                marginLeft={field.marginLeft}
                marginBottom={field.marginBottom}
                borderBottom={field.borderBottom}
                marginRight={field.marginRight}
                marginTop={field.marginTop}
                height={field.height}
                paddingPlaceholder={field.paddingPlaceholder}
                arrowMarginTop={field.arrowMarginTop}
                borderRight={field.borderRight}
                rootMarginRight={field.rootMarginRight}
                inputMarginRight={field.inputMarginRight}
                noDefaultOption={field.noDefaultOption}
                borderLeft={field.borderLeft}
                borderTop={field.borderTop}
                subMenu={field.subMenu}
            />
        </StyleDropdown>
    )
        : formMultilineInput(field);
    return (
        <Grid container spacing={1} className={classes.root}>
            {
                selectAsLeftTestTableSectionData(selectedTag, formName, formData, altTestPoint).rows.map(row => (
                    <Grid item container xs={12} key={row.key} style={{ padding: '0' }}>
                        {row.fields.map(field => (
                            <Grid item xs={field.xs} key={field.key}>
                                {field.isLabel
                                    ? (
                                        <StyleLabelText
                                            formName={formName}
                                        >
                                            <StyledLabel
                                                id={field.key}
                                                label={field.label}
                                                fontWeight={field.fontWeight}
                                                textAlign={field.textAlign}
                                                labelWidth={field.labelWidth}
                                                marginLeft={field.marginLeft}
                                                padding={field.padding}
                                                fontSize={field.fontSize}
                                                color={field.color}
                                                fontStyle={field.fontStyle}
                                            >
                                                {field.label}
                                            </StyledLabel>
                                        </StyleLabelText>
                                    )
                                    : formDropdownInput(field)}
                            </Grid>
                        )
                        )}
                    </Grid>
                ))
            }
        </Grid>
    );
};

const mapStateToProps = ({ Forms, Home }) => ({
    selectedTag: Forms.selectedTag,
    userRole: Home.userRole
});
const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AsLeftTestTableSection);

AsLeftTestTableSection.propTypes = {
    altTestPoint: PropTypes.number,
    changeHandler: PropTypes.func,
    formData: PropTypes.object,
    formName: PropTypes.string,
    isFormReadOnly: PropTypes.bool,
    selectedTag: PropTypes.object,
    updateFormData: PropTypes.func,
    userRole: PropTypes.string,
};
